export const UNICO_SDK_KEY = Symbol.for('UNICO_SDK_KEY');
